import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const FUNDING_STAGE_OPTIONS = [
  { value: '1', label: 'Angel/Pre-Seed' },
  { value: '2', label: 'Seed' },
  { value: '3', label: 'Series A' },
  { value: '4', label: 'Series B' },
  { value: '5', label: 'Series C' },
  { value: '6', label: 'Series D' },
  { value: '7', label: 'Series E+' },
  { value: '8', label: 'IPO' },
];

export const fundingStageDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.FUNDING_STAGE,
    name: 'Funding Stage',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
